
<div>
  <flex-align
    v-if="
      isGridBuilder &&
      ['GridItemWrapper', 'CContainerItem'].includes(
        selected.parent().name,
      ) &&
      !hideFlexAlignment
    "
    :mode="mode"
    :disable-alignment="hideFlexAlignment"
    :disable-constrain="hideFlexAlignment"
  ></flex-align>
  <cvt-collapse
    :accordion="true"
    :theme="mode === 'LIGHT' ? 'light' : 'dark'"
    :prepend-chevron="prependChevron"
  >
    <cvt-collapse-item
      v-if="containerItemSettings.isWrappedByCContainerItem"
      title="Container Item Options"
      :special-style="isSpecialStyle"
    >
      <c-container-item-options :mode="mode" />
    </cvt-collapse-item>
    <cvt-collapse-item
      :title="$t('elements.properties.settings')"
      name="settings"
      :initial-active="true"
      :special-style="isSpecialStyle"
    >
      <div class="row">
        <div class="col">
          <icon-manager></icon-manager>
        </div>
      </div>
      <div v-if="OrgName !== orgNameFreshWork" class="divider"></div>
      <br v-if="OrgName === orgNameFreshWork" />
      <div class="row">
        <div class="col">
          <h6 :class="textColorClass" class="m-0">Resize</h6>
        </div>
        <div class="col-12">
          <resize
            size-key="size"
            :min="1"
            :step="1"
            :max="20"
            :hide-label="true"
          ></resize>
        </div>
      </div>
      <div v-if="OrgName !== orgNameFreshWork" class="divider"></div>
      <br v-if="OrgName === orgNameFreshWork" />

      <flex-align v-if="!isGridBuilder" :mode="mode"></flex-align>

      <div v-if="OrgName !== orgNameFreshWork" class="divider"></div>
      <br v-if="OrgName === orgNameFreshWork" />

      <div class="row">
        <div v-if="isGridBuilder" class="col-12">
          Background
          <colors :to-bg="true" :mode="mode"></colors>
        </div>
        <div class="col-12">
          Foreground
          <colors :mode="mode"></colors>
        </div>
      </div>

      <div v-if="isGridBuilder" class="divider mt-2" />
      <border-style-options
        v-if="
          isGridBuilder &&
          ['GridItemWrapper', 'CContainerItem'].includes(
            selected.parent().name,
          )
        "
        :mode="mode"
        :border-style="selected.parent().borderStyle || 'none'"
        :border-color="selected.parent().borderColor || null"
        :border-width="selected.parent().borderWidth || 0"
        :border-radius="selected.parent().borderRadius || 0"
        :border-position="selected.parent().borderPosition || {}"
        :show-border-position="true"
        :update-prop-function="selected.parent().updateProp"
      />
      <element-anchor disable-alt-text></element-anchor>
    </cvt-collapse-item>

    <cvt-collapse-item
      :title="$t('elements.properties.spacing.label')"
      name="spacing"
      :special-style="isSpecialStyle"
    >
      <spacing-ctrl></spacing-ctrl>
    </cvt-collapse-item>
  </cvt-collapse>
</div>
